import { render } from "./BusinessAppointments.vue?vue&type=template&id=27a339c0"
import script from "./BusinessAppointments.vue?vue&type=script&lang=js"
export * from "./BusinessAppointments.vue?vue&type=script&lang=js"

import "./BusinessAppointments.vue?vue&type=style&index=0&id=27a339c0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__